/**
 * 商品加工单相关打印变量
 */
const skuProcessOrderTempOptions = [
  {
    label: '商品加工单',
    value: 'all',
    children: [{ label: '商品加工单(商品加工单)', value: 1 }],
  },
]
const skuProcessOrderTempJsonOptions = {
  all: {
    1: {
      panels: [
        {
          index: 0,
          name: 1,
          height: 141,
          width: 210,
          paperHeader: 120,
          paperFooter: 387.49821428571425,
          printElements: [
            {
              options: {
                left: 10.5,
                top: 6,
                height: 36,
                width: 36,
                fit: '',
                src: 'https://sh-oss-mg.oss-cn-shanghai.aliyuncs.com/img/logo.jpg',
                right: 48,
                bottom: 41.25,
                hCenter: 23.25,
                vCenter: 30,
              },
              printElementType: { title: '图片', type: 'image' },
            },
            {
              options: {
                left: 238.5,
                top: 9,
                height: 17,
                width: 120,
                right: 357.75,
                title: '商品加工单',
                bottom: 25.25,
                hCenter: 16.75,
                vCenter: 297.75,
                fontSize: 16.5,
                hideTitle: true,
                textAlign: 'center',
                fontWeight: '700',
                qrCodeLevel: 0,
                coordinateSync: false,
                widthHeightSync: false,
              },
              printElementType: { title: '标题', type: 'text' },
            },
            {
              options: {
                left: 15,
                top: 82.5,
                height: 15,
                width: 210,
                field: 'billNo',
                right: 135,
                title: '单号',
                bottom: 42,
                hCenter: 34.5,
                vCenter: 75,
                testData: '10000000000000000',
                qrCodeLevel: 0,
                coordinateSync: false,
                widthHeightSync: false,
                textContentVerticalAlign: 'middle',
              },
              printElementType: { title: '文本', type: 'text' },
            },
            {
              options: {
                left: 279,
                top: 82.5,
                height: 15,
                width: 183,
                field: 'createTime',
                right: 371.25,
                title: '录单日期',
                bottom: 42,
                hCenter: 34.5,
                vCenter: 279.75,
                testData: '2023-04-19',
                qrCodeLevel: 0,
                coordinateSync: false,
                widthHeightSync: false,
                textContentVerticalAlign: 'middle',
              },
              printElementType: { title: '文本', type: 'text' },
            },
            {
              options: { left: 13.5, top: 102, height: 9, width: 570, borderWidth: 0.75 },
              printElementType: { title: '横线', type: 'hline' },
            },
            {
              options: {
                left: 279,
                top: 105,
                height: 15,
                width: 114,
                field: 'submitManPhone',
                right: 468,
                title: '电话',
                bottom: 103.5,
                hCenter: 96,
                vCenter: 376.5,
                testData: '13112331233',
                qrCodeLevel: 0,
                coordinateSync: false,
                widthHeightSync: false,
                textContentVerticalAlign: 'middle',
              },
              printElementType: { title: '文本', type: 'text' },
            },
            {
              options: {
                left: 15,
                top: 105,
                height: 15,
                width: 232.5,
                field: 'businessGroupName',
                right: 184.5,
                title: '经营组织',
                bottom: 61.5,
                hCenter: 54,
                vCenter: 99,
                testData: '123-客户名称',
                qrCodeLevel: 0,
                coordinateSync: false,
                widthHeightSync: false,
                textContentVerticalAlign: 'middle',
              },
              printElementType: { title: '文本', type: 'text' },
            },
            {
              options: {
                left: 403.5,
                top: 105,
                height: 15,
                width: 189,
                field: 'printTime',
                right: 616.5,
                title: '打印时间',
                bottom: 102,
                hCenter: 94.5,
                vCenter: 522,
                testData: '2023-04-06',
                qrCodeLevel: 0,
                coordinateSync: false,
                widthHeightSync: false,
                textContentVerticalAlign: 'middle',
              },
              printElementType: { title: '文本', type: 'text' },
            },
            {
              options: {
                left: 13.5,
                top: 133.5,
                height: 45,
                width: 567,
                field: 'printLists',
                right: 583.5,
                bottom: 171,
                hCenter: 148.5,
                vCenter: 300,
                coordinateSync: false,
                widthHeightSync: false,
                groupFooterFormatter: 'function(t,e){return"这里自定义统计脚信息";}',
                tableHeaderBackground: '#ffffff',
                columns: [[]],
              },
              printElementType: {
                title: '表格',
                type: 'table',
                editable: true,
                columnDisplayEditable: true,
                columnDisplayIndexEditable: true,
                columnTitleEditable: true,
                columnResizable: true,
                columnAlignEditable: true,
                isEnableEditField: true,
                isEnableContextMenu: true,
                isEnableInsertRow: true,
                isEnableDeleteRow: true,
                isEnableInsertColumn: true,
                isEnableDeleteColumn: true,
                isEnableMergeCell: true,
              },
            },
            {
              options: {
                left: 15,
                top: 135,
                height: 42,
                width: 564,
                field: 'printLists',
                textAlign: 'center',
                coordinateSync: false,
                widthHeightSync: false,
                groupFooterFormatter: 'function(t,e){return"这里自定义统计脚信息";}',
                columns: [
                  [
                    {
                      width: 33.23272866666666,
                      title: '行号',
                      field: 'index',
                      checked: true,
                      columnId: 'index',
                      fixed: false,
                      rowspan: 1,
                      colspan: 1,
                      align: 'left',
                      halign: 'center',
                      tableColumnHeight: '30',
                      tableTextType: 'text',
                      tableBarcodeMode: 'CODE128A',
                      tableQRCodeLevel: 0,
                      tableSummaryTitle: true,
                      tableSummary: '',
                    },
                    {
                      width: 57.55574566666664,
                      title: '货号',
                      field: 'articleNo',
                      checked: true,
                      columnId: 'articleNo',
                      fixed: false,
                      rowspan: 1,
                      colspan: 1,
                      halign: 'center',
                      styler2:
                        "function(value,row,index,options){ return { 'max-width': '50pt', 'white-space': row.articleNo && row.articleNo.length <= 5 ? 'nowrap' : 'pre-wrap', 'transform': 'scale(0.9)' } }",
                      tableColumnHeight: '30',
                      tableTextType: 'text',
                      tableBarcodeMode: 'CODE128A',
                      tableQRCodeLevel: 0,
                      tableSummaryTitle: true,
                      tableSummary: '',
                    },
                    {
                      width: 191.42772566666665,
                      title: '品名',
                      field: 'skuName',
                      checked: true,
                      columnId: 'skuName',
                      fixed: false,
                      rowspan: 1,
                      colspan: 1,
                      styler2:
                        "function(value,row,index,options){ return { 'max-width': '150pt', 'white-space': row.skuName && row.skuName.length <= 30 ? 'nowrap' : 'pre-wrap', 'transform': 'scale(0.9)', 'overflow': 'visible' } }",
                      tableColumnHeight: '30',
                      tableTextType: 'text',
                      tableBarcodeMode: 'CODE128A',
                      tableQRCodeLevel: 0,
                      tableSummaryTitle: true,
                      tableSummary: '',
                    },
                    {
                      width: 53.74841666666663,
                      title: '规格',
                      field: 'specsDesp',
                      checked: true,
                      columnId: 'specsDesp',
                      fixed: false,
                      rowspan: 1,
                      colspan: 1,
                      tableColumnHeight: '30',
                      tableTextType: 'text',
                      tableBarcodeMode: 'CODE128A',
                      tableQRCodeLevel: 0,
                      tableSummaryTitle: true,
                      tableSummary: '',
                    },
                    {
                      width: 37.17809666666677,
                      title: '包装',
                      field: 'packageConversion',
                      checked: true,
                      columnId: 'packageConversion',
                      fixed: false,
                      rowspan: 1,
                      colspan: 1,
                      tableColumnHeight: 30,
                      tableTextType: 'text',
                      tableBarcodeMode: 'CODE128A',
                      tableQRCodeLevel: 0,
                    },
                    {
                      width: 49.4582566666666,
                      title: '数量',
                      field: 'saleQty',
                      checked: true,
                      columnId: 'saleQty',
                      fixed: false,
                      rowspan: 1,
                      colspan: 1,
                      tableColumnHeight: 30,
                      tableTextType: 'text',
                      tableBarcodeMode: 'CODE128A',
                      tableQRCodeLevel: 0,
                    },
                    {
                      width: 56.93407666666673,
                      title: '单价',
                      field: 'salePrice',
                      checked: true,
                      columnId: 'salePrice',
                      fixed: false,
                      rowspan: 1,
                      colspan: 1,
                      tableColumnHeight: '30',
                      tableTextType: 'text',
                      tableBarcodeMode: 'CODE128A',
                      tableQRCodeLevel: 0,
                      tableSummaryTitle: true,
                      tableSummary: '',
                    },
                    {
                      width: 52.62276666666663,
                      title: '金额',
                      field: 'saleAmt',
                      checked: true,
                      columnId: 'saleAmt',
                      fixed: false,
                      rowspan: 1,
                      colspan: 1,
                      tableColumnHeight: '30',
                      tableTextType: 'text',
                      tableBarcodeMode: 'CODE128A',
                      tableQRCodeLevel: 0,
                      tableSummaryTitle: true,
                      tableSummary: '',
                    },
                    {
                      width: 31.842186666666688,
                      title: '赠送',
                      field: 'ifGift',
                      checked: true,
                      columnId: 'ifGift',
                      fixed: false,
                      rowspan: 1,
                      colspan: 1,
                      formatter2: "function(value, row){return row.ifGift ? '是' :''}",
                      tableColumnHeight: '30',
                      tableTextType: 'text',
                      tableBarcodeMode: 'CODE128A',
                      tableQRCodeLevel: 0,
                      tableSummaryTitle: true,
                      tableSummary: '',
                    },
                  ],
                ],
              },
              printElementType: {
                title: '表格',
                type: 'table',
                editable: true,
                columnDisplayEditable: true,
                columnDisplayIndexEditable: true,
                columnTitleEditable: true,
                columnResizable: true,
                columnAlignEditable: true,
                isEnableEditField: true,
                isEnableContextMenu: true,
                isEnableInsertRow: true,
                isEnableDeleteRow: true,
                isEnableInsertColumn: true,
                isEnableDeleteColumn: true,
                isEnableMergeCell: true,
              },
            },
            {
              options: {
                left: 142.5,
                top: 178.5,
                height: 15,
                width: 127.5,
                field: 'totalAskAmt',
                right: 273,
                title: '原金额',
                bottom: 169.4999885559082,
                hCenter: 161.9999885559082,
                vCenter: 215.25,
                testData: '100',
                formatter: "function(value, options){return (options == 0 ? '0' : options)}",
                fontWeight: 'bold',
                qrCodeLevel: 0,
                coordinateSync: false,
                widthHeightSync: false,
                textContentVerticalAlign: 'middle',
              },
              printElementType: { title: '文本', type: 'text' },
            },
            {
              options: {
                left: 295.5,
                top: 178.5,
                height: 15,
                width: 120,
                field: 'finalZkzrAmt',
                right: 414,
                title: '优惠金额',
                bottom: 226.5,
                hCenter: 219,
                vCenter: 354,
                testData: '0',
                formatter: "function(value, options){return (options == 0 ? '0' : options)}",
                fontWeight: 'bold',
                qrCodeLevel: 0,
                coordinateSync: false,
                widthHeightSync: false,
                textContentVerticalAlign: 'middle',
              },
              printElementType: { title: '文本', type: 'text' },
            },
            {
              options: {
                left: 13.5,
                top: 178.5,
                height: 15,
                width: 114,
                field: 'totalQty',
                right: 112.5,
                title: '总数量',
                bottom: 169.4999885559082,
                hCenter: 161.9999885559082,
                vCenter: 63,
                testData: '100',
                fontWeight: 'bold',
                qrCodeLevel: 0,
                coordinateSync: false,
                widthHeightSync: false,
                textContentVerticalAlign: 'middle',
              },
              printElementType: { title: '文本', type: 'text' },
            },
          ],
          paperNumberLeft: 553.5,
          paperNumberTop: 18,
          paperNumberContinue: true,
          watermarkOptions: {},
        },
      ],
    },
  },
}

export default {
  // 商品加工单 -- 不同配送中心打印模板名
  skuProcessOrderTempOptions,
  // 商品加工单 -- 不同分公司打印模板名json
  skuProcessOrderTempJsonOptions,
}
